import React from 'react';

function ServiceApplyInfoSlide({data}) {
    return (
        <div className={'flex'}>
            <div>
                <table className={"w-full thumb-table"}>
                    <tbody>
                        <tr className={"h-[25px]"}>
                            <th>신청제목</th>
                            <td className="thumb-tr">{data.title.length > 24 ? data.title.substring(0, 23) + "..." : data.title}</td>
                        </tr>
                        <tr className={"thumb-tr"}>
                            <th>신청번호</th>
                            <td className="">{data.serialNumber}</td>
                        </tr>
                        <tr className={"thumb-tr"}>
                            <th>업무그룹</th>
                            <td className="">{data.serviceCode?.name}</td>
                        </tr>
                        <tr className={"h-[25px]"}>
                            <td colSpan={2}>
                                <span className="thumb-ag text-[11px] px-[8px] py-[3px] mr-1">요청일 : {data.createdAt} ~ {data.requestCloseDate}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default ServiceApplyInfoSlide;